import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _HealthIDType } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { HealthIDTypesSelect } from "./HealthIDTypesSelect";
import { HealthIDStructureSelect } from "../HealthIDStructure/HealthIDStructureSelect";


export const HealthIDType = () => {

    const health = useDataBean(_HealthIDType);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        health.instance.getHealthIDTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        health.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        health.deleteItemVoid(health.bean.IDHealthIDType).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        health.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDHealthIDType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Estructura', property: 'HealthIDStructureName', visible: true },
        { title: 'Formato del Código', property: 'CodeFormat', visible: true },
        { title: 'Separador', property: 'CodeSeparator', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${health.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipos de Catálogos de Códigos de Salud">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={health.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={health.bean.Name} onChange={health.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <HealthIDTypesSelect idSelector={health.bean.Type} onChange={(e) => health.setBean({ ...health.bean, "Type": e })} />
                            </div>
                            <div className="col-md-6">
                                <HealthIDStructureSelect render={health.bean.HealthIDStructureName} idSelector={health.bean.IDHealthIDStructure} onChange={(e) => { health.setBean({ ...health.bean, "IDHealthIDStructure": e.IDHealthIDStructure, "HealthIDStructureName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={health.bean.Description} onChange={health.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {health.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}